import React, { Component } from 'react';
const products = [{
  name: 'CHMER H32C',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/b25e862f90ff800ec7965b84732ad480/large-0000055_chmer-cnc-series-h32cca.jpg',
  href: '/listings/4738659-chmer-cnc-series-h32c-small-hole-drilling-edm'
}, {
  name: 'CHMER H64CL',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/ea94058e1dd24bfa7ea3b306d18021bd/large-chmer-cnc-series-h64-cl-small-hole-drilling-edm.jpg',
  href: '/listings/5584663-chmer-cnc-series-h64cl-small-hole-drilling-edm'
}, {
  name: 'CHMER H86CL',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/ca42183b8dd95a09ed52ee5586ad189a/large-0000056_chmer-cnc-series-h86c.jpg',
  href: '/listings/4738658-chmer-cnc-series-h86c-small-hole-driller-edm'
}, {
  name: 'CHMER H1080CL',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/5afe9c77037efb3d1d319198fa8c9941/large-0000707_ams-tech-ah1080.jpg',
  href: '/listings/4738663-chmer-h1080l-linear-motor-drive'
}];
export function ChmerCNCSection() {
  return <section data-id="element-1797">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1798">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1799">
          Chmer CNC H Series
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1800">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1801">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1802">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1803">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1804" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1805">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1806">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1807">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1808">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1809">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1810">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}